import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef } from 'react';
import { useDevice } from '../../providers/Device';
import { useStateInRef } from '../../utils/useStateInRef';
import { useSheetStack } from '../OverlayContext/useSheetStack';
import { GetEditableTableListTID } from './EditableTableList.types';
import { EditableTableListDesktop } from './EditableTableListDesktop';
import { EditableTableListMobile } from './EditableTableListMobile';
import { useEditableTableListDnd } from './hooks/useEditableTableListDnd';
function EditableTableListInner(param, ref) {
    let { rows, columns, getRowId, isRowStatic, disabledRowTooltip, onRemoveRow, onReorder, disableReorder, renderRowFooter, belowEditableSlot, totalSummary, totalSummaryTestId, mobileCard, hideHeaderWhenEmpty, editSheetHeader, renderEditSheetFooter, renderEditSheet, onEditDismiss, registerAddDraftHandler, renderAddDraftSheet, bi, testId } = param;
    const { EditableTableListTestIds } = useMemo(()=>GetEditableTableListTID(testId), [
        testId
    ]);
    const { isMobileDevice } = useDevice();
    const { pushBottomSheetPage, popBottomSheetPage } = useSheetStack();
    const dnd = useEditableTableListDnd({
        rows,
        getRowId,
        isRowStatic,
        onReorder,
        disableReorder
    });
    const mobileRef = useRef(null);
    const getRenderAddDraftSheet = useStateInRef(renderAddDraftSheet);
    const hasAddDraftSheet = renderAddDraftSheet != null;
    useImperativeHandle(ref, ()=>({
            openEditRow: (rowId)=>{
                var _mobileRef_current;
                return (_mobileRef_current = mobileRef.current) === null || _mobileRef_current === void 0 ? void 0 : _mobileRef_current.openEditRow(rowId);
            }
        }));
    useEffect(()=>{
        if (registerAddDraftHandler == null) return undefined;
        if (!isMobileDevice || !hasAddDraftSheet) {
            registerAddDraftHandler(null);
            return ()=>registerAddDraftHandler(null);
        }
        const handler = (item, commit)=>{
            const renderAddDraftSheetNow = getRenderAddDraftSheet();
            if (renderAddDraftSheetNow == null) return;
            pushBottomSheetPage({
                fullHeight: false,
                content: renderAddDraftSheetNow(item, {
                    commit,
                    close: popBottomSheetPage
                })
            });
        };
        registerAddDraftHandler(handler);
        return ()=>registerAddDraftHandler(null);
    }, [
        registerAddDraftHandler,
        isMobileDevice,
        hasAddDraftSheet,
        pushBottomSheetPage,
        popBottomSheetPage
    ]);
    if (isMobileDevice) {
        return /*#__PURE__*/ _jsx(EditableTableListMobile, {
            ref: mobileRef,
            rows: rows,
            columns: columns,
            getRowId: getRowId,
            disabledRowTooltip: disabledRowTooltip,
            onRemoveRow: onRemoveRow,
            renderRowFooter: renderRowFooter,
            editSheetHeader: editSheetHeader,
            renderEditSheetFooter: renderEditSheetFooter,
            renderEditSheet: renderEditSheet,
            onEditDismiss: onEditDismiss,
            belowEditableSlot: belowEditableSlot,
            totalSummary: totalSummary,
            totalSummaryTestId: totalSummaryTestId,
            mobileCard: mobileCard,
            bi: bi,
            testIds: EditableTableListTestIds,
            dnd: dnd
        });
    }
    return /*#__PURE__*/ _jsx(EditableTableListDesktop, {
        rows: rows,
        columns: columns,
        disabledRowTooltip: disabledRowTooltip,
        onRemoveRow: onRemoveRow,
        renderRowFooter: renderRowFooter,
        belowEditableSlot: belowEditableSlot,
        totalSummary: totalSummary,
        totalSummaryTestId: totalSummaryTestId,
        hideHeaderWhenEmpty: hideHeaderWhenEmpty,
        bi: bi,
        testIds: EditableTableListTestIds,
        dnd: dnd
    });
}
export const EditableTableList = /*#__PURE__*/ forwardRef(EditableTableListInner);
